import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {CellDefDirective, ColumnDefDirective} from '@i-supplier/angular-shared-module';
import {SharedModule} from '../shared/shared.module';
import {ActivityReportRoutingModule} from './activity-report-routing.module';
import {ActivitySheetListComponent} from './activity-sheet-list/activity-sheet-list.component';


@NgModule({
  declarations: [ActivitySheetListComponent],
  imports: [
    CommonModule,
    ActivityReportRoutingModule,
    SharedModule,
    FontAwesomeModule,
    ColumnDefDirective,
    CellDefDirective,
  ],
})
export class ActivityReportModule {
}
